__turbopack_context__.v({
  "container": "GjPfnG_container",
  "divider": "GjPfnG_divider",
  "links-block": "GjPfnG_links-block",
  "links-container": "GjPfnG_links-container",
  "logo": "GjPfnG_logo",
});
